"use strict";
var Observable_1 = require('../../Observable');
var windowWhen_1 = require('../../operator/windowWhen');
Observable_1.Observable.prototype.windowWhen = windowWhen_1.windowWhen;
//# sourceMappingURL=windowWhen.js.map


//////////////////
// WEBPACK FOOTER
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/~/rxjs/add/operator/windowWhen.js
// module id = ../../../../rxjs/add/operator/windowWhen.js
// module chunks = 6